import React from "react"; 
import SectionBlock from "./SectionBlock";
import powderImage from "./powder.png"; // replace with your image

const Homeblock = () => {
  return (
    <div>
      <SectionBlock
        title='"Premium Fruit Powders for Industrial Excellence"'
        description="From farm to factory, our powders are produced under strict quality controls 
        to meet the needs of industrial food processing, baby food, and health supplement 
        manufacturers etc. Consistent quality, customisable packaging, and a reliable supply are guaranteed."
        buttonText="Explore more"
        image={powderImage}
      />
    </div>
  );
};

export default Homeblock;
